import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path:'/',
      redirect:'/system-setting/apontamentos',
      name: 'home'
    },
    
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/pages/authentication/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'basic',
      },
    },
    {
      path: '/not-authorized',
      name: 'not-authorized',
      component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'basic',
      },
    },
    {
      path: '/authenticate-required',
      name: 'authenticate-required',
      component: () => import('@/views/pages/miscellaneous/AuthenticateRequired.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'basic',
      },
    },
    
    {
      path: '/system-setting/workcenters',
      name: 'workcenters',
      component: () => import('@/views/pages/system-setting/Workcenters.vue'),
      meta: {
        resource: 'operator',
        action: 'read',
        breadcrumb: [
          {
            text: 'Centros de Trabalho',
            active: true,
            icon:'settings'
          },
        ],   
      },
    },
    {
      path: '/system-setting/operator',
      name: 'operator',
      component: () => import('@/views/pages/system-setting/Operator.vue'),
      meta: {
        resource: 'pcp',
        action: 'read',
        breadcrumb: [
          {
            text: 'Cadastro Operadores',
            active: true,
            icon:'settings'
          },
        ],   
      },
    },
    {
      path: '/system-setting/apontamentos',
      name: 'apontamentos',
      component: () => import('@/views/pages/apontamentos/Apontamentos.vue'),
      meta: {
        resource: 'operator',
        action: 'read',
        breadcrumb: [
          {
            text: 'Apontamentos',
            active: true,
            icon:'apontamentos'
          },
        ],   
      },
    },
    
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  
  const isLoggedIn = isUserLoggedIn()

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next({ name: 'home' , params: {prefix: to.params.prefix}})
  }

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login', params: {prefix: to.params.prefix} })
    
    // If logged in => not authorized
    return next({ name: 'home' , params: {prefix: localStorage.getItem('prefix')}})
  }

  return next()
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
